module.exports = __webpack_public_path__ + "static/img/laughing-girl1.a0c46e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/laughing-girl1.jpg
// module id = Nf3U
// module chunks = 1